import React, { useState } from "react";
import { useApi } from "../contexts/ApiContext";

const ApiKeyScreen: React.FC = () => {
  const [apiKey, setApiKey] = useState("");
  const [error, setError] = useState("");
  const { setApiKey: saveApiKey } = useApi();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!apiKey.trim()) {
      setError("Please enter your Gemini API key");
      return;
    }

    // Basic validation - Gemini API keys typically start with 'AIza'
    if (!apiKey.startsWith("AIza")) {
      setError(
        'Invalid API key format. Gemini API keys should start with "AIza"'
      );
      return;
    }

    setError("");
    saveApiKey(apiKey.trim());
  };

  return (
    <div className="api-key-screen">
      <div className="api-key-main">
        <div className="api-key-container">
          <h1>Test Case Generator</h1>
          <p className="description">
            Enter your Google Gemini API key to start generating comprehensive
            test cases from user stories.
          </p>

          <form onSubmit={handleSubmit} className="api-key-form">
            <div className="form-group">
              <label htmlFor="apiKey">Gemini API Key</label>
              <input
                id="apiKey"
                type="password"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="Enter your Gemini API key (AIza...)"
                className="api-key-input"
              />
              {error && <div className="error-message">{error}</div>}
            </div>

            <button type="submit" className="submit-button">
              Continue
            </button>
          </form>

          <div className="help-text">
            <p>
              Don't have an API key? Get one at{" "}
              <a
                href="https://aistudio.google.com/app/apikey"
                target="_blank"
                rel="noopener noreferrer"
                className="help-link"
              >
                Google AI Studio
              </a>
            </p>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <p>
            This project is open source and created by I. Davidov. Find more
            about my work at{" "}
            <a
              href="https://idavidov.eu"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              idavidov.eu
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ApiKeyScreen;
